(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["my-custom-section"] && !Shopify.designMode) return;
  try {
    
/* ここにカスタムJavaScriptを追加 */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-section"] && !Shopify.designMode) return;
  try {
    
// ここにJavaScriptコードを追加できます。

  } catch(e) { console.error(e); }
})();
})();
